<template>
    <div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i
            ><span
                >{{ $t("app.links.budget_requests")
                }}<budget-forms-list :curFormSelect="'/form01-123'"
            /></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
                <budget-header
                    v-show="categoryMode"
                    ref="budgetHeader"
                    :form="{ spf: form.spf }"
                    :specificProp="specificProp"
                    @chgData="changeHeader"
                    :yearReq="true"
                    :openDisabled="openDisabled"
                ></budget-header>
                <p v-if="!categoryMode" class="title">
                    {{ getCommonText("decoding") }}.
                    {{ cutString(currCategory[categoryFieldNames[lng]], 80) }}
                </p>
            </div>
            <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="categoryMode && !isGkkpMode && !(progress < 100) && variantAttribute"
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadCategoryData"
                />
                <template v-if="categoryMode">
                    <div class="filter-actions filter-actions-flex">
                        <c-budget-forms-copy-rows
                            ref="cBudgetFormCopyRows"
                            v-if="isCopyRowsBtnVisible && categoryMode && variantAttribute"
                            :header="header"
                            :budgetForm="budgetForm"
                            :isHasDecodeTable="true"
                            :categoryFieldNames="categoryFieldNames"
                            :uuidv4="uuidv4"
                            :getErrText="getErrText"
                            :makeToast="makeToast"
                            @updtHeader="updtHeader"
                            @addItem="addItem"
                            @reloadTable="loadCategoryData"
                        />
                        <c-budget-forms-copy-data
                            v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)"
                            :budgetForm="budgetForm"
                            :header="header"
                            :isLoad="isLoad"
                            @keyPress="keyPress"
                        />
                        <b-button
                            variant="primary"
                            @click="onAddNewCat"
                            v-if="variantAttribute"
                            :disabled="isLoad || !areAllRequiredFieldsValid"
                            ><i class="icon icon-plus-circle"></i>
                            {{ getCommonText("add") }}</b-button
                        >
                    </div>
                </template>
                <template v-else>
                    <b-button variant="light" @click="resetModal">
                        <i class="icon icon-keyboard icon-rotate-180"></i
                        >{{ getCommonText("back_to_list") }}
                    </b-button>
                    <b-button
                        :style="{ minWidth: '110px' }"
                        v-if="variantAttribute"
                        variant="primary"
                        @click="$refs.formTemplate.addItem()"
                    >
                        <i class="icon icon-plus-circle"></i
                        >{{ getCommonText("add") }}
                    </b-button>
                    <b-button
                        :style="{ minWidth: '110px' }"
                        :disabled="!isDataChanged || goodsAreSaving"
                        variant="success"
                        @click="prepareForSave"
                    >
                        {{ getCommonText("save") }}
                    </b-button>
                </template>
            </div>
        </div>

        <filter-empty-placeholder v-if="enteredFromOtherMode" />
        <template v-else>
        <div v-show="categoryMode" class="table-container">
            <b-overlay :show="isLoad" rounded="sm">
                <b-overlay :show="mainTableOverlay" rounded="sm">
                <b-table
                    :fields="tableFields"
                    :items="budgetForm"
                    responsive="true"
                    bordered
                    head-variant="light"
                    sticky-header="true"
                    no-border-collapse
                >
                    <template #top-row="data">
                        <td></td>
                        <td></td>
                        <td class="td-numbering text-center table-success">1</td>
                        <td class="td-numbering text-center table-danger">2</td>
                        <td class="td-numbering text-center table-info">3</td>
                        <td class="td-numbering text-center table-primary">4</td>
                        <td class="td-numbering text-center table-warning">5</td>
                        <td class="td-numbering text-center table-success">6</td>
                        <td class="td-numbering"></td>
                    </template>
                    <template #head(selection)>
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="selectAll"
                                @change="(e) => setIsAllDelete(e)"
                                :value="true"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #head(more)>
                        <div class="text-center">
                            <i
                                :title="getCommonText('del_selected')"
                                class="icon icon-close table-all-remove"
                                @click="
                                    deleteItem(
                                        `${
                                            selectAll
                                                ? getCommonText('all_cats')
                                                : getCommonText('selected_cats')
                                        }`
                                    )
                                "
                            />
                        </div>
                    </template>
                    <template #cell(selection)="data">
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="data.item.itemToDelete"
                                @input="
                                    (e) => {
                                        selectCheckBoxClicked(e);
                                        if (!e) selectAll = false;
                                    }
                                "
                                :value="true"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #cell(action)="data">
                        <div class="text-center">
                            <button
                                class="table-plus"
                                v-b-modal.goods-modal
                                @click="setCurrCatName(data.item)"
                                :disabled="!isDecodeAvailable(data.item)"
                            >
                                <i class="icon icon-plus-circle" />
                            </button>
                        </div>
                    </template>
                    <template #cell(name)="data">
                        <div class="column-width-100 bp-category-name">
                            <div>{{ data.item[categoryFieldNames[lng]] }}</div>
                            <i
                                v-if="variantAttribute"
                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                @click="onEditCatName(data.item)"
                            ></i>
                        </div>
                    </template>
                    <template #cell(unit_code)="data">
                        <div v-if="variantAttribute">
                            <multiselect
                                :value="getUnitOption(data.item.unit_code)"
                                style="min-width: 150px"
                                label="text"
                                track-by="value"
                                :options="getUnitOptions(data.item)"
                                :placeholder="getUnitsText('select_unit')"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false"
                                :disabled="data.item.nameUpdating"
                                @input="(v) => onUnitSelect(data.item, v.value)"
                            ></multiselect>
                        </div>
                        <div v-else class="text-center">
                            {{ getUnitShortName(data.item.unit_code) }}
                        </div>
                    </template>
                    <template #cell(amount)="data">
                        <div class="text-right">{{ $n(data.value) }}</div>
                    </template>
                    <template #cell(cost)="data">
                        <div class="text-right">{{ $n(data.value) }}</div>
                    </template>
                    <template #cell(total)="data">
                        <div class="text-right">{{ $n(data.value) }}</div>
                    </template>
                    <template #cell(files)="data">
                        <span
                            class="blue pointer underline"
                            @click="onAllFilesClick(data.item)"
                            >({{
                                data.item.files ? data.item.files.length : 0
                            }})</span
                        >
                    </template>
                    <template #cell(more)="data">
                        <div class="text-center">
                            <i
                                class="icon icon-clear table-remove"
                                v-if="variantAttribute"
                                :disabled="isLoad"
                                @click="
                                    deleteItem(
                                        getCommonText('curr_cat'),
                                        { ...data.item, good_type: data.item },
                                        data.index,
                                        true
                                    )
                                "
                            ></i>
                        </div>
                    </template>
                    <template #bottom-row="data">
                        <td class="text-right" colspan="6">
                            {{ getCommonText("total") }}
                        </td>
                        <td class="text-right">{{ $n(total) }}</td>
                        <td colspan="2"></td>
                    </template>
                </b-table>
                </b-overlay>
            </b-overlay>
            <div
                class="table-add"
                v-if="variantAttribute"
                :disabled="isLoad || !areAllRequiredFieldsValid"
            >
                <span
                    @click="onAddNewCat"
                    :class="{ 'bf-disabled': isLoad || !areAllRequiredFieldsValid }"
                    ><i class="icon icon-plus-circle"></i>
                    {{ getCommonText("add") }}</span
                >
            </div>
        </div>
        <template v-if="!categoryMode">
            <b-overlay :show="templateTableOverlay" rounded="sm">
                <form-template13
                    ref="formTemplate"
                    :goodsData="goodsData"
                    :header="header"
                    :initialGoodsData="initialGoodsData"
                    :ensTruDict="ensTruDict"
                    :variantAttribute="variantAttribute"
                    :currCategory="currCategory"
                    :lang="lang"
                    :ifAllFieldsFilled="ifAllFieldsFilled"
                    @deleteGood="deleteGood"
                    :ensTruNamePrt="ensTruNamePrt"
                    :ensTruName="ensTruName"
                    :descIsLoading="descIsLoading"
                    :parNameLoading="parNameLoading"
                    :allFiles="allFiles"
                    :isLoad="isLoad"
                    :triggDownloadFile="triggDownloadFile"
                    :triggDownloadAllFiles="triggDownloadAllFiles"
                    :showFileUploadModal="showFileUploadModal"
                    :getEnstruByName="getEnstruByName"
                    :loadCurUnits="loadCurUnits"
                    :currUnits="currUnits"
                    :getUnitName="getUnitName"
                    :goodsAreSaving="goodsAreSaving"
                    :isDoubleDecodeExist="isDoubleDecodeExist"
                    :isFieldValid="isFieldValid"
                    @setDataChanged="setDataChanged"
                    @setItemTotal="setItemTotal"
                    @searchName="searchName"
                    @setIsAllDelete="setIsAllDelete"
                    @decodeDataValidation="isDecodeDataValid"
                    @doublesValidationDecodes="doublesValidationDecodes"
                    @addGoodsOrderNum="addGoodsOrderNum"
                ></form-template13>
                <div class="table-add" v-if="variantAttribute">
                    <span @click="$refs.formTemplate.addItem()"
                        ><i class="icon icon-plus-circle"></i>
                        {{ getCommonText("add") }}</span
                    >
                </div>
            </b-overlay>
        </template>
        <files-updown
            v-if="isFilterReady"
            ref="filesUpdown"
            v-show="categoryMode"
            :header="header"
            :variant-attribute="variantAttribute"
            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
            :load="isLoad"
            :showDeleteLinks="variantAttribute"
            :showDeleteAll="true"
            @getFiles="getFiles"
            @fillFilesList="fillFilesList"
            @restetFilesList="restetFilesList"
            @delelteAttachedFile="delelteAttachedFile"
            @onFilePreview="onFilePreview"
        ></files-updown>
        <modal-all-files-management
            ref="modalAllFilesManagement"
            :allFiles="allFiles"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
        >
        </modal-all-files-management>
        <c-set-b-f-category-name
            ref="setCatNameModal"
            :budgetForm="budgetForm"
            :categoryFieldNames="categoryFieldNames"
            :lng="lng"
            :getCommonText="getCommonText"
            @addItem="addItem"
            @onCatNameChanged="onCatDataChanged"
        />
        </template>
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import BudgetHeader from "@/modules/budget-request/budget-header-new.vue";
import FilesUpdown from "@/modules/budget-request/FilesUpdown";
import BudgetFormsList from "@/modules/budget-request/components/budget-forms-list.vue";
import FormsHandlerMixin from "./mixins/forms-handler-mixin";
import { specificProp } from "./components/js/budgetFormsLst";
import FormTemplate13 from "./components/budget-forms-template13.vue";
import ModalAllFilesManagement from "./components/modal-all-files-management.vue";
import FormsDownloadReprt from "./components/forms-download-reprt.vue";
import CSetBFCategoryName from "./components/c-set-bf-category-name.vue";
import FilterEmptyPlaceholder from "@/modules/budget-request/components/filter-empty-placeholder.vue";
import CBudgetFormsCopyData from "./components/budget-forms-copy-data.vue";
import CBudgetFormsCopyRows from "./components/budget-forms-copy-rows.vue";
import CBudgetFormsDataTransfer from "./components/budget-forms-data-transfer.vue";

export default {
    name: "Form04_149",
    components: {
        BudgetHeader,
        FilesUpdown,
        BudgetFormsList,
        FormsDownloadReprt,
        FormTemplate13,
        ModalAllFilesManagement,
        CSetBFCategoryName,
        FilterEmptyPlaceholder,
        CBudgetFormsCopyData,
        CBudgetFormsCopyRows,
        CBudgetFormsDataTransfer,
    },
    mixins: [FormsHandlerMixin],
    data() {
        return {
            form: {
                code: "04-149",
                spf: {
                    name: "149 - Приобретение прочих запасов",
                    spf: "149",
                },
            },
            isDataChanged: false,
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            formFilter: null,
            budgetForm: [],
            header: null,
            files: null,
            openDisabled: false,
            isLoad: true,
            isReportUploading: false,
            specificProp: specificProp,
            categoryFieldNames: { ru: "name_ru", kk: "name_kk" },
            unitStatDict: [],
        };
    },

    created() {
        this.$emit("setForm", this.form);
    },
    mounted() {
        this.progress = 15;
    },
    watch: {
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },
        categoryMode() {
            this.$emit("setCategoryMode", this.categoryMode);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        }
    },
    methods: {
        itemUpdate(item, nameRu, nameKk) {
            this.$set(item, "name_ru", nameRu);
            this.$set(item, "name_kk", nameKk);
            this.$set(item, "category_id", this.uuidv4());
            this.$set(item, "unit_code", null);
            this.$set(item, "amount", 0);
            this.$set(item, "cost", 0);
            this.$set(item, "total", 0);
            this.$set(item, "files", []);
            this.$set(item, "newCat", true);
            this.$set(item, "nameUpdating", true);
            this.$set(item, "itemToDelete", false);

            // RQ.eAk.BRF04_149.06.2, шаг 1: сохранение позиции сразу после подтверждения
            // наименования в модальном окне, единица измерения на этом шаге еще не известна
            this.saveNewCategory(item);
        }, // заполнение полей при добавлении новой категории

        async saveNewCategory(item) {
            await this.saveCategoryChanges(item, {
                name_ru: item.name_ru,
                name_kk: item.name_kk,
            });
            this.$set(item, "nameUpdating", false);
        },

        onUnitSelect(item, code) {
            this.$set(item, "unit_code", code);
            this.onUnitChanged(item);
        },

        onUnitChanged(item) {
            // защита от гонки: пока не завершился шаг 1 (создание позиции), id еще отрицательный
            if (item.id < 0) return;
            this.saveCategoryChanges(item, { unit_code: item.unit_code });
        }, // RQ.eAk.BRF04_149.06.2, шаг 2: сохранение выбранной единицы измерения отдельным запросом

        async saveCategoryChanges(item, payload) {
            this.isLoad = true;
            const data = {
                item: { id: item.id, category_id: item.category_id, ...payload },
                header: this.header,
            };
            try {
                const response = await fetch("/api-py/save-brform04-149/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    body: JSON.stringify(data),
                });
                if (response.status === 200) {
                    const result = await response.json();
                    if (result.result === "success") {
                        if ("new_id" in result) {
                            this.$set(item, "id", result.new_id);
                        }
                    } else if (result.result === "duplicate") {
                        // RQ.eAk.BRF04_149.07: серверный контроль дублей - защита на случай обхода
                        // клиентской проверки в модальном окне c-set-bf-category-name.vue
                        this.makeToast(
                            "warning",
                            this.getCommonText("attention"),
                            this.getCommonText("exist")
                        );
                        if (item.id < 0) {
                            const idx = this.budgetForm.indexOf(item);
                            if (idx !== -1) this.budgetForm.splice(idx, 1);
                        }
                    } else {
                        throw this.getErrText("not_saved");
                    }
                } else {
                    throw this.getErrText("not_saved");
                }
            } catch (e) {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    e.toString()
                );
            }
            this.selectAll = false;
            this.isLoad = false;
            this.enableCopyRowsComponent();
        },

        async loadCategoryData() {
            this.selectAll = false;
            this.setIsCopyRowsBtnVisible(false);
            this.isLoad = true;
            this.budgetForm.splice(0);
            const data = { ...this.header, form_version: "04-149" };
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-cat/" +
                        JSON.stringify(data)
                );
                if (response.status === 200) {
                    const values = await response.json();
                    values.forEach((val) => {
                        const item = {
                            id: val.id,
                            name_ru: val.name_ru,
                            name_kk: val.name_kk,
                            category_id: val.category_id,
                            unit_code: val.unit_code,
                            amount: val.amount,
                            cost: val.cost,
                            total: val.total,
                            newCat: false,
                            nameUpdating: false,
                            files: this.getUnicFilesArr(val),
                            itemToDelete: false,
                        };
                        this.budgetForm.push(item);
                    });
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadCategoryData()`,
                    error.toString()
                );
            }
            this.isLoad = false;
        },

        setItemTotal(item) {
            // RQ.eAk.BRF04_149.24: общая стоимость строки расшифровки = количество * стоимость / 1000
            Object.defineProperty(item, "total", {
                get: () => {
                    const amount = this.safeDecimal(item.amount);
                    const cost = this.safeDecimal(item.cost);
                    return amount
                        .mul(cost)
                        .div(1000)
                        .toDecimalPlaces(3)
                        .toNumber();
                },
            });
        },

        inputFixed(item, field, value, digit, defaultVal = 0) {
            const newVal = parseFloat(value)
                ? parseFloat(parseFloat(value).toFixed(digit))
                : defaultVal;
            if (newVal !== item[field]) {
                this.$set(item, field, newVal);
                return "changed";
            }
            return "not changed";
        }, // форматирует введенное значение до digit цифр после запятой

        async save(values) {
            this.saveDecodes(values);
        },

        async saveDecodes(values) {
            this.isLoad = true;
            const dataToSave = {
                values,
                header: this.header,
            };

            try {
                const url = "/api-py/save-brform04-149-decode/";
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    body: JSON.stringify(dataToSave),
                });
                const result = await response.json();
                if (response.status === 200) {
                    if (result.result === "success") {
                        this.dataChanged = false;
                        this.loadGoodsData(this.currCategory);
                        this.updateDatas();
                        this.selectAll = false;
                        this.makeToast(
                            "success",
                            this.getErrText("msg"),
                            this.getErrText("saved")
                        );
                        this.deletingAgreementTotalResultHandler(result);
                    } else if (result.result === "validation_error") {
                        // RQ.eAk.BRF04_149.18-19, АС 3: серверный контроль обязательных полей -
                        // защита на случай, если фронтовые проверки template13 обойдены
                        this.makeToast(
                            "warning",
                            this.getCommonText("attention"),
                            this.getCommonText("not_selected")
                        );
                        this.goodsAreSaving = false;
                    } else if (result.result === "duplicate") {
                        // RQ.eAk.BRF04_149.21, АС 4: серверный контроль дублей расшифровки
                        this.makeToast(
                            "warning",
                            this.getCommonText("attention"),
                            this.getCommonText("exist")
                        );
                        this.goodsAreSaving = false;
                    } else {
                        this.goodsAreSaving = false;
                        throw this.getErrText("not_saved");
                    }
                } else {
                    this.goodsAreSaving = false;
                    throw this.getErrText("not_saved");
                }
            } catch (e) {
                this.goodsAreSaving = false;
                this.makeToast("danger", this.getErrText("warning"), e.toString());
            } finally {
                this.isLoad = false;
            }
        }, // сохранение данных расшифровки

        async loadGoodsData(cat) {
            if (!cat.category_id) return;
            this.templateTableOverlay = true;
            this.initialGoodsData = {};
            const newHeader = {
                ...this.header,
                cat_code: cat.category_id,
                form: "04-149",
            };
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-goods/",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(newHeader),
                    }
                );
                if (response.status === 200) {
                    const values = await response.json();
                    await this.ensTruDataAddingToGoods(values);
                    process.nextTick(() => {
                        values.forEach((val) => {
                            this.$set(val, "isNew", false);
                            this.$set(val, "rowToSave", false);
                            this.$set(
                                val,
                                "currGoodDesc",
                                this.ensTruName.filter(
                                    (ens) => ens.code === val.enstru_code
                                )[0]
                            );
                            this.$set(
                                val,
                                "ensTruName",
                                this.ensTruName.filter(
                                    (itm) =>
                                        itm["name_" + this.lang] === val.name
                                )
                            );
                            this.$set(val, "itemToDelete", false);
                            this.$set(val, "isHasDouble", false);
                            this.isDecodeDataValid(val);
                            this.setItemTotal(val);

                            this.initialGoodsData[val.id] = {
                                ...val,
                                total: val.total,
                            };
                        });
                        this.goodsData = values.sort((a, b) => a.id - b.id);
                        this.addGoodsOrderNum();
                        this.doublesValidationDecodes();
                        this.setDataChanged();
                    });
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadGoodsData()`,
                    error.toString()
                );
            }
            this.templateTableOverlay = false;
            this.goodsAreSaving = false;
        }, // загрузка списка расшифровок

        deleteItem(msg, row = false) {
            if (
                !this.variantAttribute ||
                this.isLoad ||
                (!row &&
                    this.budgetForm.findIndex((itm) => itm.itemToDelete) === -1)
            )
                return;

            if (row) this.currCategory = row.category_id;

            this.$bvModal
                .msgBoxConfirm(
                    this.getCommonText("del_with_decodes", { msg: msg }),
                    {
                        title: this.getCommonText("confirm"),
                        size: "lg",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: this.getCommonText("yes"),
                        cancelTitle: this.getCommonText("cancel"),
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(async (value) => {
                    if (value) {
                        if (row) {
                            if (row.id >= 0) {
                                this.deleteRows([row], "category");
                            }
                            const idxToDel = this.budgetForm.findIndex(
                                (itm) => itm.id === row.id
                            );
                            this.budgetForm.splice(idxToDel, 1);
                        } else {
                            const existingRowsToDel = this.budgetForm.filter(
                                (item) => item.id >= 0 && item.itemToDelete
                            );
                            this.budgetForm = this.budgetForm.filter(
                                (item) => !item.itemToDelete
                            );

                            if (!existingRowsToDel.length) {
                                this.selectAll = false;
                            } else {
                                await this.deleteRows(
                                    existingRowsToDel,
                                    "category"
                                );
                            }
                        }
                    }
                })
                .catch((error) => {
                    this.makeToast(
                        "danger",
                        this.getCommonText("on_del"),
                        error.toString()
                    );
                });
        }, // RQ.eAk.BRF04_149.30, АС 6: удаление позиции удаляет и всю ее расшифровку на бэкенде

        async deleteRows(items, mode) {
            this.isLoad = true;
            const data = {
                item: items,
                header: this.header,
                mode: mode,
                form: "04-149",
            };
            try {
                const response = await fetch(
                    "/api-py/delete-list-budget-request-form/",
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(data),
                    }
                );
                if (response.ok) {
                    const result = await response.json();
                    this.updateDatas();
                    this.makeToast(
                        "success",
                        this.getErrText("msg"),
                        this.getErrText("one_deleted")
                    );
                    this.deletingAgreementTotalResultHandler(result);
                }
            } catch {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    this.getErrText("on_del")
                );
            }
            this.isLoad = false;
        }, // удаление данных

        addGoodsOrderNum() {
            this.goodsData.forEach((item, i) => {
                this.$set(item, "order_num", i + 1);
            });
        },

        fillDataForSave(item, row) {
            this.$set(item, "category_id", this.currCategory.category_id);
            this.$set(item, "cost", parseFloat(row.cost));
            this.$set(item, "amount", parseFloat(row.amount));
        }, // заполнение полей при подготовке к сохранению строк расшифровки

        prepareData(val) {
            // расшифровка 04-149 не хранит наименование категории в отдельном текстовом поле
        },

        getFiles(data) {
            this.files = data;
        },

        keyup13: function (event) {
            event.preventDefault();
            const currentNode = event.target;
            const allElements = document.querySelectorAll("input");
            const currentIndex = [...allElements].findIndex((el) =>
                currentNode.isEqualNode(el)
            );
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        onCatDataChanged(row) {
            // вызывается общей модалкой наименования и при добавлении (row={}), и при правке (row=позиция);
            // добавление уже обработано в itemUpdate/saveNewCategory - здесь обрабатывается только правка
            if (Object.keys(row).length === 0) return;
            if (!this.isCatDataValid(row)) return;

            this.saveCategoryChanges(row, {
                name_ru: row.name_ru,
                name_kk: row.name_kk,
            });
        },

        isCatDataValid(row) {
            const isNameRuValid = !!(row.name_ru && row.name_ru.trim().length > 0);
            const isNameKkValid = !!(row.name_kk && row.name_kk.trim().length > 0);
            return isNameRuValid || isNameKkValid;
        }, // RQ.eAk.BRF04_149.06: обязательно хотя бы одно из наименований

        isDecodeAvailable(item) {
            // RQ.eAk.BRF04_149.09: кнопка расшифровки неактивна, пока не заполнены
            // наименование и единица измерения позиции
            return (
                this.isCatDataValid(item) &&
                !!item.unit_code &&
                !item.nameUpdating
            );
        },

        async loadDict() {
            this.setFormVersion();
            await this.loadUnitStatDict();
        },

        setFormVersion() {
            this.header.form_version = "04-149";
        },

        async loadUnitStatDict() {
            // RQ.eAk.BRF04_149.17.4: справочник единиц измерения ОСНОВНОЙ формы (dict_unit_stat),
            // бэкенд уже отбирает только элементы с заполненным par_id. Не путать с this.unitsBase -
            // тот заполняется миксином из dict_mkei_stat и используется для единиц измерения в
            // расшифровке (template13, getUnitName)
            try {
                const response = await fetch("/api-py/dictionary_units/");
                if (response.status === 200) {
                    this.unitStatDict = await response.json();
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadUnitStatDict`,
                    error.toString()
                );
            }
        },

        getUnitFullName(unit) {
            if (!unit) return "";
            return this.lng === "kk"
                ? unit.name_kz || unit.name_ru
                : unit.name_ru;
        }, // RQ.eAk.BRF04_149.17.2: полное наименование - для выпадающего списка

        getUnitOption(code) {
            const option = this.unitOptions.find((option) => option.value === code);
            if (!option) return null;
            return { ...option, text: this.getUnitShortName(code) };
        }, // связывает unit_code с объектом опции для multiselect; текст выбранного значения - краткое обозначение

        getUnitOptions(item) {
            return this.unitOptions.map((option) =>
                option.value === item.unit_code
                    ? { ...option, $isDisabled: true }
                    : option
            );
        }, // уже выбранная единица измерения недоступна для повторного выбора в списке

        getUnitShortName(code) {
            const unit = this.unitStatDict.find((item) => item.code === code);
            if (!unit) return "";
            if (this.lng === "kk") {
                return unit.national_symbol_kz || unit.name_kz || unit.name_ru;
            }
            return unit.national_symbol || unit.name_ru;
        }, // RQ.eAk.BRF04_149.17.2: краткое обозначение - после выбора в поле

        isDecodeDataValid(row) {
            const isCostValid = this.isFieldValid(row.cost);
            const isAmountValid = this.isFieldValid(row.amount);
            const isRowValid = isCostValid && isAmountValid;
            this.$set(row, "isCostValid", isCostValid);
            this.$set(row, "isAmountValid", isAmountValid);
            this.$set(row, "isRowValid", isRowValid);
            return isRowValid;
        },

        ifAllFieldsFilled() {
            const prevNewItemIdx = this.goodsData.findIndex(
                (item) => item.isNew === true
            );
            if (prevNewItemIdx !== -1) {
                const prevNewItem = this.goodsData[prevNewItemIdx];
                if (!prevNewItem.enstru_code) {
                    this.makeToast(
                        "warning",
                        this.getCommonText("attention"),
                        this.getCommonText("not_selected")
                    );
                    return false;
                }
            }
            if (this.goodsData.some((item) => !item.isAmountValid)) {
                this.makeToast(
                    "warning",
                    this.getCommonText("attention"),
                    this.getCommonText("amnt_more_zero")
                );
                return false;
            }
            if (this.goodsData.some((item) => !item.isCostValid)) {
                this.makeToast(
                    "warning",
                    this.getCommonText("attention"),
                    this.getCommonText("cost_more_zero")
                );
                return false;
            }
            if (prevNewItemIdx !== -1)
                this.$set(this.goodsData[prevNewItemIdx], "isNew", false);
            return true;
        }, // проверка заполненности полей в расшифровке

        setDataChanged(val = null) {
            if (val !== null) {
                this.isDataChanged = val;
                return;
            }
            this.isDataChanged = this.goodsData.some((item) => item.rowToSave);
        },

        resetModal(bvModalEvent) {
            if (this.isDataChanged && bvModalEvent) {
                bvModalEvent.preventDefault();
                this.onGoodsModalClose();
            } else {
                this.categoryMode = true;
                this.goodsData.splice(0);
            }
        }, // очистка формы расшифровки при закрытии без сохранения

        updateTotalBeforeSave() {
            // отключение метода из миксина - итог формы пересчитывается на бэкенде
        },

        getFormCode() {
            return "04-149";
        },

        getCodeFieldName() {
            return "category_id";
        },

        async updateDatas(onlyCat = false) {
            // В отличие от generic-версии из forms-handler-mixin.js, параметр onlyCat
            // здесь НЕ используется для пропуска перезагрузки расшифровки: deleteGood
            // (forms-handler-mixin.js) вызывает updateDatas(true) после удаления строки
            // расшифровки, а таблица goodsData в 04-149 полагалась только на локальный
            // splice() в budget-forms-template13.vue. Из-за расхождений (гонка, повторное
            // открытие категории, частичный сбой массового удаления) в таблице оставалась
            // "призрачная" строка, которой уже нет в БД - поэтому здесь goodsData всегда
            // подстраховочно перезапрашивается с сервера, если открыта категория расшифровки.
            await this.loadCategoryData();
            if (this.currCategory && this.currCategory.category_id) {
                this.loadGoodsData(this.currCategory);
            }
        },

        isFieldValid(value) {
            return value !== null && value !== "" && value > 0;
        },
    },
    computed: {
        total() {
            // RQ.eAk.BRF04_149.29.1: итог формы не читается из свода, а пересчитывается
            // по данным формы при каждом открытии/изменении
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.total) || 0;
            }
            return Math.ceil(sum);
        },

        getFormText() {
            return this.setFormText("form_04_149.");
        },

        unitOptions() {
            return this.unitStatDict.map((unit) => ({
                value: unit.code,
                text: this.getUnitFullName(unit),
            }));
        },

        areAllRequiredFieldsValid() {
            // кнопка "Добавить" неактивна, пока есть незаполненная категория:
            // не введено наименование ни на одном языке или не выбрана единица измерения
            return this.budgetForm.every(
                (item) => this.isCatDataValid(item) && !!item.unit_code
            );
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: "selection",
                        label: " ",
                    },
                    {
                        key: "action",
                        label: " ",
                    },
                    {
                        key: "name",
                        label: this.getCommonText("name"),
                    },
                    {
                        key: "unit_code",
                        label: this.getFormText("unit_code"),
                    },
                    {
                        key: "amount",
                        label: this.getFormText("amount"),
                    },
                    {
                        key: "cost",
                        label: this.getFormText("cost"),
                    },
                    {
                        key: "total",
                        label: this.getFormText("total"),
                    },
                    {
                        key: "files",
                        label: this.getCommonText("files"),
                    },
                    {
                        key: "more",
                        label: "",
                    },
                ];
            }
            return [];
        },
    },
};
</script>

<style scoped>
.error input {
    padding-left: 25px;
}
.filter-actions-flex {
    display: flex;
}
.table-plus {
    border: none;
}
.bp-category-name {
    display: flex;
    justify-content: space-between;
}
.bp-category-name .icon-pencil-edit {
    align-self: center;
}
.bf-disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
}
</style>
